import { ValidationSchema } from 'validation-schema-library';

const backgroundCheckValidationSchema: ValidationSchema = {
  performedAt: {
    type: 'date',
    maxDate: {
      value: '$NOW',
      message: 'Cannot be in future',
    },
    required: true,
  },
  result: {
    type: 'enum',
    required: true,
  },
  attachmentsIds: {
    type: 'array',
    maxSize: 10,
    required: true,
  },
};

const getBackgroundCheckValidationSchema = () => Promise.resolve(backgroundCheckValidationSchema);

export default getBackgroundCheckValidationSchema;
